import { toast } from "react-toastify";

interface ICopyToClipboardArgs {
  text: string;
  successToastId?: string | undefined;
  successMessage?: string;
  errorMessage?: string;
  type?: string;
}

export const copyToClipboard = async ({
  text,
  successMessage = "Success to copy!",
  errorMessage = "Failed to copy!",
  type = "text/plain",
}: ICopyToClipboardArgs) => {
  const blob = new Blob([text], { type });
  const data = [new ClipboardItem({ [type]: blob })];

  try {
    await navigator.clipboard.write(data);
    toast.success(successMessage);
  } catch {
    toast.error(errorMessage);
  }
};
